import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import { push } from 'react-router-redux';
import {
  FLAG_GETTING_MATERIALS,
  GET_MATERIALS,
  CLEAR_MATERIALS,
  FLAG_MATERIAL_ACTIVITY,
  GET_MATERIAL,
  CLEAR_MATERIAL,
} from '../types/mechanical-maintenance';
import { MATERIAL_ENDPOINT } from '../../config/endpoints';
import {
  DEFAULT_GET_CONFIG,
  DEFAULT_POST_CONFIG,
  DEFAULT_DELETE_CONFIG,
  DEFAULT_PUT_CONFIG,
} from '../../config/rest';
import { isErrorResponse } from '../../utils/error-handlers';
import { MATERIAL_PATH } from '../../config/paths';

const flagGettingMaterials = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_MATERIALS,
    payload: flag,
  });

const getMaterials = async (tableFilters) => async (dispatch) => {
  try {
    dispatch(flagGettingMaterials(true));
    const query = tableFilters;
    const url = `${MATERIAL_ENDPOINT}?${QueryString.stringify(query)}`;
    const promise = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(promise, null, dispatch);
    const response = await promise.json();
    dispatch({
      type: GET_MATERIALS,
      payload: response,
    });
  } catch ({ message }) {
    toastr.error('Error', message);
  } finally {
    dispatch(flagGettingMaterials(false));
  }
};

const clearMaterials = () => (dispatch) =>
  dispatch({
    type: CLEAR_MATERIALS,
  });

const flagMaterialActivity = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_MATERIAL_ACTIVITY,
    payload: flag,
  });

const getMaterial =
  async ({ materialId }) =>
  async (dispatch) => {
    try {
      dispatch(flagMaterialActivity(true));
      const url = `${MATERIAL_ENDPOINT}/${materialId}`;
      const promise = await fetch(url, DEFAULT_GET_CONFIG);
      await isErrorResponse(promise, null, dispatch);
      const response = await promise.json();
      dispatch({
        type: GET_MATERIAL,
        payload: response,
      });
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagMaterialActivity(false));
    }
  };

const clearMaterial = () => (dispatch) =>
  dispatch({
    type: CLEAR_MATERIAL,
  });

const postMaterial =
  async ({ name, externalId, measurementUnit }) =>
  async (dispatch) => {
    try {
      dispatch(flagMaterialActivity(true));
      const payload = {
        name,
        externalId,
        measurementUnit,
      };
      const url = MATERIAL_ENDPOINT;
      const promise = await fetch(url, {
        ...DEFAULT_POST_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(promise, null, dispatch);
      await promise.json();
      dispatch(push(MATERIAL_PATH));
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagMaterialActivity(false));
    }
  };

const deleteMaterial =
  async ({ materialId }) =>
  async (dispatch) => {
    try {
      dispatch(flagMaterialActivity(true));
      const url = `${MATERIAL_ENDPOINT}/${materialId}`;
      const promise = await fetch(url, {
        ...DEFAULT_DELETE_CONFIG,
      });
      await isErrorResponse(promise, null, dispatch);
      await promise.json();
      dispatch(push(MATERIAL_PATH));
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagMaterialActivity(false));
    }
  };

const putMaterial =
  async (materialId, { name, externalId, measurementUnit }) =>
  async (dispatch) => {
    try {
      dispatch(flagMaterialActivity(true));
      const payload = {
        id: materialId,
        name,
        externalId,
        measurementUnit,
      };
      const url = `${MATERIAL_ENDPOINT}/${materialId}`;
      const promise = await fetch(url, {
        ...DEFAULT_PUT_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(promise, null, dispatch);
      await promise.json();
      dispatch(push(MATERIAL_PATH));
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagMaterialActivity(false));
    }
  };

export {
  flagGettingMaterials,
  getMaterials,
  clearMaterials,
  flagMaterialActivity,
  getMaterial,
  postMaterial,
  clearMaterial,
  deleteMaterial,
  putMaterial,
};
